/** 模拟语言 - 开发环境 */
// const MOCK_LANG = 'zh-CN'
const MOCK_LANG = 'en-US'
// const MOCK_LANG = 'zh-TW'

/** 当前系统语言 */
export const CURRENT_LANG = process.env.NODE_ENV === 'development' ? MOCK_LANG : navigator?.language

/** 简体中文类型 */
export const SIMPLE_LANG = ['zh-CN', 'zh-SG', 'zh-Hans']

/** 繁体中文类型 */
export const COMPLEX_LANG = ['zh-TW', 'zh-HK', 'zh-MO', 'zh-Hant']

/** 国际化语言判断工具 */
export const $t = (cn, enFont, complexFont) => {
  const lang = CURRENT_LANG
  if (lang?.startsWith('zh')) {
    if (SIMPLE_LANG.includes(lang)) return cn
    if (COMPLEX_LANG.includes(lang)) return complexFont || languagesData[cn]?.complex || cn
    return cn
  }
  if (lang?.startsWith('en')) {
    return enFont || languagesData[cn]?.en || cn
  }
  return cn
}

/** 国际化语言翻译词条 */
export const languagesData = {
  '登录': {
      complex: '登錄',
      en: 'Login'
  },
  '账号登录': {
      complex: '賬號登錄',
      en: 'Account login'
  },
  '请输入账号或邮箱': {
      complex: '請輸入賬號或郵箱',
      en: 'Please enter your account number or email address'
  },
  '请输入密码': {
      complex: '請輸入密碼',
      en: 'Please enter your password'
  },
  '忘记密码': {
      complex: '忘記密碼',
      en: 'Forgot password'
  },
  '邮箱登录': {
      complex: '郵箱登錄',
      en: 'Email login'
  },
  '账号注册': {
      complex: '賬號註冊',
      en: 'Account registration'
  },
  '联系客服': {
      complex: '聯繫客服',
      en: 'Support'
  },
  '本地账号': {
      complex: '本地賬號',
      en: 'Local account'
  },
  '账号已生成，注意保存': {
      complex: '賬號已生成，注意保存',
      en: 'The account has been generated. Please keep it safe.'
  },
  '账号': {
      complex: '賬號',
      en: 'Account'
  },
  '密码': {
      complex: '密碼',
      en: 'Password'
  },
  '切换账号': {
      complex: '切換賬號',
      en: 'Switch account'
  },
  '自动登录中': {
      complex: '自動登錄中',
      en: 'Automatically logging in'
  },
  '关闭': {
      complex: '關閉',
      en: 'Close'
  },
  '立即联系': {
      complex: '立即聯繫',
      en: 'Contact immediately'
  },
  '邮箱': {
      complex: '郵箱',
      en: 'Email'
  },
  '时间': {
      complex: '時間',
      en: 'Time'
  },
  '点击“立即联系”无反应，请手动添加QQ': {
      complex: '點擊“立即聯繫”無反應，請手動添加QQ',
      en: 'Clicking "Contact immediately" has no response. Please manually add QQ.'
  },
  '登录中': {
      complex: '登錄中',
      en: 'Logging in'
  },
  '登录成功': {
      complex: '登錄成功',
      en: 'Login successful'
  },
  '登录失败': {
      complex: '登錄失敗',
      en: 'Login failed'
  },
  '正在尝试跳转QQ': {
      complex: '正在嘗試跳轉QQ',
      en: 'Trying to jump to QQ'
  },
  '暂未开通充值通道': {
      complex: '暫未開通充值通道',
      en: 'The recharge channel is not available yet.'
  },
  '加载中': {
      complex: '加載中',
      en: 'Loading'
  },
  '绑定邮箱': {
      complex: '綁定郵箱',
      en: 'Bind email'
  },
  '建议绑定邮箱': {
      complex: '建議綁定郵箱',
      en: 'It is recommended to bind an email.'
  },
  '当前账号安全系数低': {
      complex: '當前賬號安全係數低',
      en: 'The current account has a low security level.'
  },
  '请输入邮箱': {
      complex: '請輸入郵箱',
      en: 'Please enter your email'
  },
  '换绑邮箱': {
      complex: '換綁郵箱',
      en: 'Change the bound email'
  },
  '验证原邮箱': {
      complex: '驗證原郵箱',
      en: 'Verify the original email'
  },
  '绑定新邮箱': {
      complex: '綁定新郵箱',
      en: 'Bind a new email'
  },
  '请输入当前绑定邮箱码': {
      complex: '請輸入當前綁定郵箱碼',
      en: 'Please enter the verification code of the currently bound email'
  },
  '请输入将要绑定的邮箱码': {
      complex: '請輸入將要綁定的郵箱碼',
      en: 'Please enter the verification code of the email to be bound'
  },
  '开始验证': {
      complex: '開始驗證',
      en: 'Start verification'
  },
  '重新绑定': {
      complex: '重新綁定',
      en: 'Rebind'
  },
  '请输入验证码': {
      complex: '請輸入驗證碼',
      en: 'Please enter the verification code'
  },
  '正在绑定邮箱': {
      complex: '正在綁定郵箱',
      en: 'Binding email...'
  },
  '绑定成功': {
      complex: '綁定成功',
      en: 'Binding successful'
  },
  '绑定失败': {
      complex: '綁定失敗',
      en: 'Binding failed'
  },
  '验证成功': {
      complex: '驗證成功',
      en: 'Verification successful'
  },
  '验证失败': {
      complex: '驗證失敗',
      en: 'Verification failed'
  },
  '正在验证原邮箱': {
      complex: '正在驗證原郵箱',
      en: 'Verifying the original email'
  },
  '请输入账号': {
      complex: '請輸入賬號',
      en: 'Please enter your account'
  },
  '注册': {
      complex: '註冊',
      en: 'Register'
  },
  '请填写完整': {
      complex: '請填寫完整',
      en: 'Please fill in completely'
  },
  '账号名不能带空格': {
      complex: '賬號名不能帶空格',
      en: 'The account name cannot contain spaces.'
  },
  '请输入长度10位以内的账号名': {
      complex: '請輸入長度10位以內的賬號名',
      en: 'Please enter an account name within 10 characters.'
  },
  '注册中': {
      complex: '註冊中',
      en: 'Registering'
  },
  '找回密码': {
      complex: '找回密碼',
      en: 'Retrieve password'
  },
  '修改密码': {
      complex: '修改密碼',
      en: 'Change password'
  },
  '请选择支付方式': {
      complex: '請選擇支付方式',
      en: 'Please select a payment method'
  },
  '确认': {
      complex: '確認',
      en: 'Confirm'
  },
  '请输入旧密码': {
      complex: '請輸入舊密碼',
      en: 'Please enter your old password'
  },
  '请输入新密码': {
      complex: '請輸入新密碼',
      en: 'Please enter your new password'
  },
  '请确认新密码': {
      complex: '請確認新密碼',
      en: 'Please confirm your new password'
  },
  '重置成功': {
      complex: '重置成功',
      en: 'Reset successful'
  },
  '重置失败': {
      complex: '重置失敗',
      en: 'Reset failed'
  },
  '账号名': {
      complex: '賬號名',
      en: 'Account name'
  },
  '前往绑定': {
      complex: '前往綁定',
      en: 'Go to bind'
  },
  '返回': {
      complex: '返回',
      en: 'Back'
  },
  '用户': {
      complex: '用戶',
      en: 'User'
  },
  '注销': {
      complex: '註銷',
      en: 'Logout'
  },
  '客服': {
      complex: '客服',
      en: 'Service'
  },
  '修复': {
      complex: '修復',
      en: 'Repair'
  },
  '加群': {
      complex: '加群',
      en: 'QQ'
  },
  '礼包': {
      complex: '禮包',
      en: 'Gift'
  },
  '公告': {
      complex: '公告',
      en: 'Announcement'
  },
  '公众号': {
      complex: '公眾號',
      en: 'Wechat'
  },
  '优惠券': {
      complex: '優惠券',
      en: 'Coupon'
  },
  '确认注销并重新登录': {
      complex: '確認註銷並重新登錄',
      en: 'Confirm cancellation and log in again'
  },
  '秒后重新发送': {
      complex: '秒後重新發送',
      en: 'seconds, Resend after'
  },
  '获取验证码': {
      complex: '獲取驗證碼',
      en: 'Get verification code'
  },
  '验证码发送中': {
      complex: '驗證碼發送中',
      en: 'Sending verification code'
  },
  '验证码已发送': {
      complex: '驗證碼已發送',
      en: 'Verification code has been sent'
  },
  '发送失败': {
      complex: '發送失敗',
      en: 'Sending failed'
  },
  '提示': {
      complex: '提示',
      en: 'Tip',
  },
  '加载游戏': {
      complex: '加載遊戲',
      en: 'Load game',
  },
  '元': {
    complex: '$',
    en: '$',
  },
  '充值中心': {
      complex: '充值中心',
      en: 'Recharge Center'
  },
  '充值金额': {
      complex: '充值金額',
      en: 'Recharge Amount'
  },
  '充值已受理，到账结果以游戏中为准': {
      complex: '充值已受理，到賬結果以遊戲中為準',
      en: 'The recharge has been accepted. The arrival result shall be subject to the game.'
  },
  '返回游戏': {
      complex: '返回遊戲',
      en: 'Return to the game'
  },
  '确认支付': {
      complex: '確認支付',
      en: 'Confirm Payment'
  },
  '取消': {
      complex: '取消',
      en: 'Cancel'
  },
  '可用优惠券': {
      complex: '可用優惠券',
      en: 'Available Coupons'
  },
  '已选择1张优惠券': {
      complex: '已選擇1張優惠券',
      en: '1 coupon has been selected.'
  },
  '新人券': {
      complex: '新人券',
      en: 'Newcomer Coupon'
  },
  '普通券': {
      complex: '普通券',
      en: 'Regular Coupon'
  },
  '已经到底了': {
      complex: '已經到底了',
      en: 'You\'ve reached the end.'
  },
  '支付链接不存在': {
      complex: '支付鏈接不存在',
      en: 'The payment link does not exist.'
  },
  '支付失败': {
      complex: '支付失敗',
      en: 'Payment Failed'
  },
  '支付异常，请重试': {
      complex: '支付異常，請重試',
      en: 'Payment error. Please try again.'
  },
  '获取可用优惠券失败': {
      complex: '獲取可用優惠券失敗',
      en: 'Failed to get available coupons.'
  },
  '支付中心必须使用SSL协议，如有问题，请联系技术人员': {
      complex: '支付中心必須使用SSL協議，如有問題，請聯繫技術人員',
      en: 'The payment center must use the SSL protocol. If you have any problems, please contact the technical staff.'
  },
  '隐私协议': {
      complex: '隱私協議',
      en: 'Privacy Policy',
  },
  '同意': {
    complex: '同意',
    en: 'Consent',
  },
  '社交媒体': {
      complex: '社交媒體',
      en: 'Social Media'
  },
  '加入': {
      complex: '加入',
      en: 'Join'
  },
  '链接无效': {
      complex: '鏈接無效',
      en: 'Invalid link'
  },
}
